import type {TimeRangeInterface} from '@shared/interfaces/timerange'

export const DEFAULT_TIME_RANGE_OPTIONS: TimeRangeInterface[] = [
  {id: 0, value: '00:15:00', name: 'last_15_minutes'},
  {id: 1, value: '00:30:00', name: 'last_30_minutes'},
  {id: 2, value: '01:00:00', name: 'last_1_hour'},
  {id: 3, value: '04:00:00', name: 'last_4_hours'},
  {id: 4, value: '08:00:00', name: 'last_8_hours'},
  {id: 5, value: '12:00:00', name: 'last_12_hours'},
  {id: 6, value: '1 00:00:00', name: 'one_day'},
  {id: 7, value: '2 00:00:00', name: 'two_days'},
  {id: 8, value: '3 00:00:00', name: 'three_days'},
  {id: 9, value: '7 00:00:00', name: 'one_week'},
  {id: 10, value: '14 00:00:00', name: 'two_weeks'},
  {id: 11, value: '28 00:00:00', name: 'one_month'},
  {id: 12, value: 'three-months', name: 'three_months'},
  {id: 13, value: 'six-months', name: 'six_months'},
  {id: 14, value: 'twelve-months', name: 'twelve_months'},
  {id: 15, value: 'shift-so-far', name: 'shift_so_far'},
  {id: 16, value: 'day-so-far', name: 'day_so_far'},
  {id: 17, value: 'week-so-far', name: 'week_so_far'},
  {id: 18, value: 'month-so-far', name: 'month_so_far'},
  {id: 19, value: 'quarter-so-far', name: 'quarter_so_far'},
  {id: 20, value: 'year-so-far', name: 'year_so_far'},
  {id: 21, value: 'null', name: 'custom'},
]

/**
 * Dashboards also offer "previous shift", the last completed shift (AB#6936), right
 * after "shift so far". Only the dashboard pages handle its fixed end.
 */
export const DASHBOARD_TIME_RANGE_OPTIONS: TimeRangeInterface[] =
  DEFAULT_TIME_RANGE_OPTIONS.flatMap((option) =>
    option.value === 'shift-so-far'
      ? [option, {id: 22, value: 'previous-shift', name: 'previous_shift'}]
      : [option],
  )
